import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import theme from 'source/theme';
import history from 'source/history';
import { whoAmI } from 'utils/startApp';
import { BOOT, FULFILLED, LOGIN } from './actionTypes';
import router from './router';
import store from './store';

// Ask who is asking, then start. `whoAmI` hits /users/me, which answers
// `{ id, account_id }` from the session cookie, or 401. There is no token to
// read and no profile to fetch ahead of the boot: the id is the whole of "who",
// and the row it points at arrives with /users/ inside the boot like every other
// row.
//
// Both facts go into `state.auth` before the boot starts, and the boot takes no
// argument: each scoped collection reads the account from the store when its own
// fetch runs - see `sagasHelpers.fetchPaginated`.
whoAmI()
  .then((payload) => {
    store.dispatch({ type: LOGIN + FULFILLED, payload });
    // ⚠️ LOGIN + FULFILLED is dispatched here, so `boot` must not `take` it - a
    // barrier waiting for an action that already fired never resolves, and the
    // app would sit on the loader for ever.
    store.dispatch({ type: BOOT });
  })
  .catch(() => {
    history.push('/login');
    console.log('Redirected to Login, user not authenticated');
  })
  .finally(() => {
    // React 19: `ReactDOM.render` is gone. The root is created once and
      // rendered into - the same single mount this always was, since
      // `.finally` runs exactly once whichever way whoAmI settles.
      // The theme wraps the ROUTER, not the shell. Under router 5 the provider
      // sat above `<Switch>`, so it covered /login, /forgot_password,
      // /password_recovery and /logout as well - those four are siblings of the
      // shell, not children of it, because /login must draw no header and sit
      // behind no guard. Router 7 turned the shell into a layout route and the
      // provider went inside it, which quietly took the theme away from the four
      // public pages: they fell back to MUI's own defaults and the login screen
      // came up purple. CssBaseline was above the Switch too, for the same reason.
      createRoot(document.getElementById('root')).render(
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline/>
            <RouterProvider router={router}/>
          </MuiThemeProvider>
        </Provider>
      );
  });
